import { Component, input } from '@angular/core';

type IncidentStatus = 'has-incident' | 'no-incident';

@Component({
  selector: 'app-pan-incident-status-chip',
  templateUrl: './pan-incident-status-chip.component.html',
  styleUrl: './pan-incident-status-chip.component.scss',
  standalone: false,
})
export class PanIncidentStatusChipComponent {
  public status = input.required<IncidentStatus>();
  public count = input<number>(0);
}
